import { render, staticRenderFns } from "./new-repeat-pickure-table.vue?vue&type=template&id=2ed932ca&scoped=true&"
import script from "./new-repeat-pickure-table.vue?vue&type=script&lang=js&"
export * from "./new-repeat-pickure-table.vue?vue&type=script&lang=js&"
import style0 from "./new-repeat-pickure-table.vue?vue&type=style&index=0&id=2ed932ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed932ca",
  null
  
)

export default component.exports